<template>
    <div class="relative overflow-hidden">
        <div class="box-content relative flex flex-col md:flex-row justify-center gap-4 md:px-[40px] lg:px-[100px]">
            <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-teal-500 font-sans">Cooperation</h3>
            <div class="relative my-4 lg:my-8 md:pt-6 flex flex-col lg:flex-row justify-center gap-4">
                <div class="relative order-1 lg:order-2 h-40 md:h-60 lg:h-fit">
                    <img class="object-cover object-center w-full h-full lg:w-[500px] lg:h-64 custom-shape" src="@/assets/img/about/about-9.jpg" alt="cooperation">
                </div>
                <div class="relative z-10 order-2 lg:order-1 w-full lg:max-w-[600px] py-2 lg:px-8 lg:py-4 text-center my-auto">
                    <h3 class="text-orange-900 uppercase font-normal text-2xl sm:text-4xl lg:text-5xl">Chiến lược</h3>
                    <p class="text-justify my-3 lg:my-6 font-light text-md sm:text-lg"><i>"Trên cơ sở sự ủng hộ của Ban Giám đốc, các ban chức năng của Đại học Huế đặc biệt là sự ủng hộ của đội ngũ khoa học hoạt động trong lĩnh cực kỹ thuật và công nghệ. Khoa Kỹ thuật và Công nghệ sẽ chủ động xây dựng các mối mối liên hệ hợp tác quốc tế đã được thiết lập từ các đơn vị đã có với Đại học Huế"</i></p> 
                </div>
                <div data-aos="fade-right" data-aos-duration="1500" class="absolute z-0 top-0 left-0 md:left-12 hidden md:block">
                    <h3 class="text-transparent text-7xl md:text-[150px] lg:text-[200px] text-center font-outline-4">HUET</h3>
                </div>
            </div>
        </div>
        <div class="box-content md:px-[60px] lg:px-[100px] pt-0 flex flex-col md:flex-row md:gap-3 lg:gap-8 xl:gap-16">
            <div class="relative h-fit w-fit mx-auto mb-3">
                <h3 class="about-header-text w-fit lg:w-max mx-auto min-w-[180px] lg:min-w-[260px] text-center md:text-left header-underline pb-1 sm:pb-2">
                    Chiếc lược hợp tác
                </h3>
                <span class="d-md-none d-lg-block absolute w-1/2 h-[3px] bg-blue-600 bottom-0 rounded-r-xl"></span>
            </div>
            <div class="flex flex-col gap-2 text-lg">
                <p class="text-justify about-description-text px-1 sm:px-3 xl:ml-16">
                    Khoa Kỹ thuật và Công nghệ chủ động kết nối và đẩy mạnh liên kết và hợp tác với các đối tác tiềm năng mới nhằm đáp ứng 
                    chương trình đào tạo quốc tế tiên tiến như các trường công lập Lamas, Bang Texas, Mỹ, Đại học Missouri State và ĐH Missouri, 
                    Mỹ; các đại học ở các nước có Kỹ thuật và công nghệ phát triển như Nhật Bản, Hàn Quốc, Đài Loan.
                </p>
                <p class="text-justify about-description-text px-1 sm:px-3 xl:ml-16">
                    Bên cạnh việc xây dựng chương trình đào tạo liên kết theo mô hình <i>3+1+1</i> (nhận bằng Thạc sĩ) hay <i>3+1</i>, <i>2+2</i> (Hai đơn vị cấp bằng) 
                    thì việc phát triển xây dựng liên kết hợp tác trong nghiên cứu và xuất bản là nhiệm vụ quan trọng ngay từ ban đầu từ các tổ 
                    chức quốc tế, các nước như DAAD, Erasmus+, NAGAO, CDR-Áo, JICA-Nhật, KOICA- Hàn Quốc hay Australia Awards Vietnam.
                </p>
            </div>
        </div>
        <div class="box-content md:px-[60px] lg:px-[100px] flex flex-col gap-2 md:gap-4 bg-slate-100">
            <h2 class="h-fit text-3xl lg:text-4xl text-orange-900 text-center mb-2 font-semibold">Liên kết đào tạo tại HUET</h2>
            <div>
                <h3 class="text-xl font-semibold text-left mb-1">1. Hợp tác với các trường Đại học</h3>
                <p class="text-xl text-justify text-black">
                    Để thực hiện tốt các nhiệm vụ hợp tác, ngay những ngày đầu thành lập Khoa chủ động xây dựng mạng lưới liên kết với các 
                    trường có bề dày trong đào tạo kỹ thuật và công nghệ trong nước như Trường Đại học Bách Khoa Hà Nội, Trường Đại học 
                    Bách Khoa Thành phố Hồ Chí Minh, Trường ĐH Sư Phạm Kỹ thuật TPHCM, Trường Đại học Công nghệ, Đại học Quốc Gia Hà Nội, 
                    Đại học Xây Dựng Hà Nội, Đại học Thủy Lợi, Đại học Giao Thông Vận Tải, Học viện Công nghệ Bưu chính Viễn thông để tìm 
                    hướng liên kết, phát triển và xây dựng mô hình đào tạo cũng như tận dụng nguồn lực về các nhà khoa học của các đơn vị 
                    trong việc tham gia cố vấn, góp ý và đào tạo cũng như xây dựng chuẩn đầu ra phù hợp với nguồn nhân lực quốc gia và quốc 
                    tế cho Khoa.
                </p>
            </div>
            <div>
                <h3 class="text-xl font-semibold text-left mb-1">2. Hợp tác doanh nghiệp</h3>
                <p class="text-xl text-justify text-black">
                    Xác định vai trò liên kết doanh nghiệp trong hoạt động liên kết đào tạo, chuyển giao khoa học và công nghệ là hết sức 
                    cần thiết. Chính vì vậy việc xây dựng các môi liên kết chiến lược với doạnh nghiệp trong nước và quốc tế cần được chú 
                    trọng và đẩy mạnh với nhiều hình thức hợp tác theo cơ chế <i>Win-Win</i>. Một số mô hình hợp tác điển hình như sau:
                </p>
                <p class="text-xl text-justify text-black pt-1">
                    <b>Hợp tác cùng xây dựng chương trình đào tạo theo mô hình doanh nghiệp:</b> 
                    Doanh nghiệp tham gia cùng với Khoa xây dựng chương trình gắn với với doanh, 
                    từ đó xác định chuẩn đầu ra cho ngành học phù hợp với xu thế chung và phù hợp với hoạt động của doanh nghiệp
                </p>
                <p class="text-xl text-justify text-black pt-1">
                    <b>Đào tạo tại doanh nghiệp:</b> Sinh viên có thời gian đào tạo tại doạnh nghiệp, doanh nghiệp cử chuyên gia 
                    hướng dẫn cùng với giảng viên của khoa các đề án, đề tài theo mô hình PL (Project Learning) thời gian đào tạo 
                    tương ứng khoảng 36-40 tín chỉ (2 học kỳ).
                </p>
                <p class="text-xl text-justify text-black pt-1">
                    <b>Hợp tác cung ứng nhân lực cho doanh nghiệp:</b> tìm kiếm đối tác có đủ năng lực sử dụng nhân lực và xây dựng 
                    hợp tác chiến lược (doanh nghiệp cho sinh viên vay vốn học) hỗ trợ cơ sở vật chất cho đơn vị đào tạo và được sử 
                    dụng nhân lực đào tạo từ Khoa.
                </p>
                <p class="text-xl text-justify text-black pt-1">
                    <b>Hợp tác xây dựng đào tạo cùng với doanh nghiệp:</b> các khóa chuyên sâu ngắn hạn, các khóa chuyển đổi nghề nghiệp tập 
                    trung cho nhân lực công nghệ thông tin
                </p>
            </div>
            <div>
                <h3 class="text-xl font-semibold text-left mb-1">3. Hợp tác quốc tế</h3>
                <p class="text-xl text-justify text-black">
                    Với mục tiêu nâng cao chất lượng đào tạo và đáp ứng nhu cầu ngày càng cao của thị trường lao động, HUET đã kết nối với 
                    các đối tác quốc tế để cung cấp cho sinh viên những khóa học chuyên sâu, đào tạo các kỹ năng và công nghệ mới nhất, 
                    cũng như cơ hội thực tập và làm việc tại các công ty công nghệ hàng đầu trên thế giới. Với mục tiêu nâng cao chất lượng 
                    đào tạo và đáp ứng nhu cầu ngày càng cao của thị trường lao động, HUET đã kết nối với các đối tác quốc tế 
                    để cung cấp cho sinh viên những khóa học chuyên sâu, đào tạo các kỹ năng và công nghệ mới nhất, cũng như cơ hội thực tập 
                    và làm việc tại các công ty công nghệ hàng đầu trên thế giới.
                </p>
            </div>
            <vue-horizontal-list :items="staffEntries" :options="options" v-if="!loading">
                <template v-slot:nav-next class="bg-transparent">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg>
                    </div>
                </template>
                <template v-slot:nav-prev>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg>
                    </div>
                </template>
                <template v-slot:default="{ item }">
                    <div class="item">
                        <img class="rounded-full w-[220px] h-[220px] object-cover mx-auto image_hover" :src="$addPrefix(item.image)" @error="replaceBrokenImage" alt="staff-image">
                        <h5 class="text-center mt-3 font-semibold">{{ item.name }}</h5>
                    </div>
                </template>
            </vue-horizontal-list>
        </div>
        <div v-if="!loading" class="box-content md:px-[60px] lg:px-[100px] grid grid-cols-12 gap-4 lg:gap-8">
            <div class="col-span-12 lg:col-span-9 flex flex-col gap-6 lg:gap-8 ">
                <div class="flex flex-col md:flex-row gap-2 md:gap-4" v-for="(item, index) in cooperationEntries" :key="index">
                    <img class="w-full h-60 sm:h-80 md:w-52 md:h-52 object-cover shadow-sm shadow-black" :src="$addPrefix(item.image)" :alt="item.name" v-viewer>
                    <div class="flex flex-col align-middle my-auto gap-2">
                        <h4 class="text-2xl font-semibold">{{ item.name }}</h4>
                        <p class="text-xl text-justify" v-html="item.description"></p>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-3">
                <h4 class="text-xl md:text-2xl font-semibold text-left mb-2">Tin tức liên quan</h4>
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-1 gap-4">
                    <div v-for="(entry, index) in newsEntries" :key="index" :class="{'d-none': index>2}">
                        <div class="shadow-lg shadow-black bg-white w-full h-fit relative" :class="{'sm:hidden md:block lg:hidden': index == 2}">
                            <img :src="entry.image" class="w-full h-[150px] sm:h-[120px] lg:h-[150px] object-cover object-center cursor-pointer" alt="news-thumbnail" @click="pushNewsDetail(entry._id)">
                            <div class="px-[8px] py-2 md:px-3 flex flex-col gap-2">
                                <h5 class="mb-0 font-semibold cursor-pointer truncate" @click="pushNewsDetail(entry._id)">{{ entry.name }}</h5>
                                <p class="line-clamp-2 w-full mb-0" v-html="entry.description"></p>
                                <div class="flex justify-between">
                                    <p class="mb-0 text-gray-400 font-semibold">{{ getDateTime(entry.updatedAt) }}</p>
                                    <p class="mb-0 pr-2 hover:text-prime-color cursor-pointer font-semibold" @click="pushNewsDetail(entry._id)">Đọc ngay</p>
                                </div>
                            </div>
                            <b-badge variant="warning" class="absolute top-3 left-3"><h6 class="mb-0 font-semibold">{{ entry.type }}</h6></b-badge>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import VueHorizontalList from 'vue-horizontal-list';
import Loading from '@/components/loading'
import { mapActions } from 'vuex';
export default {
    components: {
        VueHorizontalList, Loading
    },
    data() {
        return {
            options: {
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { start: 768, end: 992, size: 3 },
                { start: 992, end: 1280, size: 4 },
                { size: 5 },
                ],
                list: {
                // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
                windowed: 1280,
                padding: 24,
                },
                position: {
                start: 2,
                },
                autoplay: { play: true, repeat: true, speed: 3000 },
            },
            staffEntries: [],
            cooperationEntries: [],
            newsEntries: [],
            loading: true
        }
    },
    methods: {
        ...mapActions('staff', ['GetStaffList']),
        ...mapActions('news', ['GetLatestNewsList']),
        ...mapActions('cooperation', ['GetCooperationList']),
		replaceBrokenImage(event) {
			event.target.src = require("@/assets/img/error/no-university.png");
		},
        async getUniversities() {
            const response = await this.GetStaffList()
            if (response.data.code == 200) {
                this.staffEntries = response.data.data
            }
        },
        async getCooperation() {
            const response = await this.GetCooperationList()
            if (response.code == 200) {
                this.cooperationEntries = response.data
            }
        },
        async getCooperationNews(){
            let response = await this.GetLatestNewsList("Hợp tác")
            this.newsEntries = response.data.data
        },
		getDateTime(rawData) {
			return (
				rawData.substring(8, 10) +
				"-" +
				rawData.substring(5, 7) +
				"-" +
				rawData.substring(0, 4)
			);
		},
        pushNewsDetail(id) {
            this.$router.push({path: '/news/detail/' + id})
        }
    },
    async created() {
        await this.getUniversities()
        await this.getCooperation()
        await this.getCooperationNews()
        this.loading = false
    }
}
</script>

<style scoped>
.custom-shape {
    clip-path: polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%);
}
</style>